import { render, staticRenderFns } from "./hd_banner.vue?vue&type=template&id=6b79bccc&scoped=true"
import script from "./hd_banner.vue?vue&type=script&lang=js"
export * from "./hd_banner.vue?vue&type=script&lang=js"
import style0 from "./hd_banner.vue?vue&type=style&index=0&id=6b79bccc&prod&scoped=true&lang=less"
import style1 from "./hd_banner.vue?vue&type=style&index=1&id=6b79bccc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b79bccc",
  null
  
)

export default component.exports